import styled from 'styled-components';
import { SonntagButtonV2 } from '@getgrover/ui';
import { Paragraph } from 'ggApp/shared/common/Typography';
import DivisionLine from 'ggApp/shared/components/layout/divisionLine';
import CircleLoader from 'ggApp/shared/components/CircleLoader';

const Wrap = styled.div`
    display: flex;
    flex-direction: column;
`;

const Loader = styled(CircleLoader)`
    height: 64px;
    margin-top: 16px;
    ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
        > * {
            margin-top: ${() => theme.spacers.XXL};
        }
    `}
`;

const NoResultsWrap = styled.div``;

const Line = styled(DivisionLine)`
    margin: ${({ theme }) => `12px ${theme.spacers.L} ${theme.spacers.S}`};
`;

const NoResultsText = styled(Paragraph)`
    color: ${({ theme }) => theme.colors.Foreground};
    margin-left: ${({ theme }) => theme.spacers.L};
`;

const Button = styled(SonntagButtonV2)`
    margin: ${({ theme }) => `${theme.spacers.M} auto 0 ${theme.spacers.L}`};
    flex: 0 0 auto;
    ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
        margin: ${theme.spacers.L} ${theme.spacers.XL} auto;
    `};
`;

export {
    Wrap,
    Loader,
    NoResultsWrap,
    Line,
    NoResultsText,
    Button,
};
